export default function FooterSection() {
  const socials = [
    { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/clwizard', label: 'Facebook' },
    { icon: 'ri-instagram-fill', href: 'https://www.instagram.com/clwizard/', label: 'Instagram' },
    { icon: 'ri-youtube-fill', href: 'https://www.youtube.com/@CLwizard', label: 'YouTube' },
    { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/in/marcofilhoengineer/', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-[#060912] border-t border-white/5 py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 mb-10">
          {/* Logo + tagline */}
          <div className="text-center md:text-left">
            <img
              src="https://clwizard.com/wp-content/uploads/2022/05/Blushot-Logo-2-®.png"
              alt="CLWizard Logo"
              className="h-12 w-auto object-contain mb-3 mx-auto md:mx-0"
            />
            <p className="text-gray-400 text-sm font-medium italic">
              We don&apos;t patch leaks. We engineer permanent solutions.
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-end gap-3">
            <a
              href="tel:5617745120"
              className="flex items-center gap-2 text-white hover:text-[#4d8fff] transition-colors font-semibold text-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center text-[#0055ff]">
                <i className="ri-phone-fill"></i>
              </span>
              (561) 774-5120
            </a>
            <a
              href="mailto:info@clwizard.com"
              className="flex items-center gap-2 text-white hover:text-[#4d8fff] transition-colors font-semibold text-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center text-[#0055ff]">
                <i className="ri-mail-fill"></i>
              </span>
              info@clwizard.com
            </a>
          </div>
        </div>

        {/* Socials */}
        <div className="flex justify-center md:justify-start gap-4 mb-10">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label={s.label}
              className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-[#0055ff]/20 border border-white/10 hover:border-[#0055ff]/40 rounded-full text-gray-400 hover:text-white transition-all duration-200"
            >
              <i className={`${s.icon} text-base`}></i>
            </a>
          ))}
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            &copy; 2024 CLWizard&reg;. All rights reserved.
          </p>
          <p className="text-gray-700 text-xs">
            The Concrete Leak Specialist — South Florida
          </p>
        </div>
      </div>
    </footer>
  );
}
